<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        large
        ref="Modal"
        title="Parametrização do tipo de atendimento médico"
    >
        <Form
            :data="data"
            :index="index"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null
    }),
    methods: {
        open(index) {

            this.index = index

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)

            this.$refs.Modal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>